/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Log video badge link to console
  document.addEventListener('DOMContentLoaded', function () {
    const videoBadgeElement = document.getElementById('video-badge-data-{{ unique }}');
    if (videoBadgeElement) {
      const videoBadgeLink = videoBadgeElement.getAttribute('data-video-badge-link');
      console.log('Video Badge Link:', videoBadgeLink);
    }
  });

  // Color name updater for product swatches
  document.addEventListener('DOMContentLoaded', function() {
    
    // Function to update color name display
    function updateColorName(input) {
      const colorName = input.getAttribute('data-color-name');
      const swatchContainer = input.closest('[data-swatches-container]');
      
      if (swatchContainer && colorName) {
        const colorNameDisplay = swatchContainer.querySelector('[data-selected-color-name]');
        if (colorNameDisplay) {
          colorNameDisplay.textContent = colorName;
        }
      }
    }

    // Handle swatch inputs (for color swatches)
    const swatchInputs = document.querySelectorAll('.swatch__input[data-color-name]');
    swatchInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        if (this.checked) {
          updateColorName(this);
        }
      });
    });

    // Handle radio button inputs (for variant option images)
    const radioInputs = document.querySelectorAll('.radio__input[data-color-name]');
    radioInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        if (this.checked) {
          updateColorName(this);
        }
      });
    });

    // Initialize with currently selected color on page load
    const checkedSwatchInput = document.querySelector('.swatch__input[data-color-name]:checked');
    if (checkedSwatchInput) {
      updateColorName(checkedSwatchInput);
    }

    const checkedRadioInput = document.querySelector('.radio__input[data-color-name]:checked');
    if (checkedRadioInput) {
      updateColorName(checkedRadioInput);
    }
  });

  // Log on-sale variant data when swatch is clicked
  document.addEventListener('DOMContentLoaded', function() {
    
    // Handle swatch button clicks
    document.addEventListener('click', function(event) {
      const swatchButton = event.target.closest('[data-swatch-button]');
      
      if (swatchButton) {
        const productBlock = swatchButton.closest('[data-product-block]');
        const swatchLabel = swatchButton.querySelector('[data-swatch-variant]');
        
        if (productBlock && swatchLabel) {
          // Get the variants on sale data (format: "variantId:true,variantId2:false")
          const variantsOnSaleData = productBlock.dataset.variantsOnSale;
          const variantId = swatchLabel.dataset.swatchVariant;
          

          
          try {
            // Parse the simple format into an object
            const variantsOnSale = {};
            if (variantsOnSaleData && variantsOnSaleData.trim() !== '') {
              // Split by comma to get each variant entry
              const entries = variantsOnSaleData.split(',');
              entries.forEach(entry => {
                if (entry.includes(':')) {
                  const [id, isOnSale] = entry.split(':');
                  if (id && isOnSale !== undefined) {
                    variantsOnSale[id.trim()] = isOnSale.trim() === 'true';
                  }
                }
              });
            }
            
            const isVariantOnSale = variantsOnSale[variantId];
            
            // Find both the red SALE badge and custom badge in this product
            const redSaleBadge = productBlock.querySelector('.product-badge__item--sale-red');
            const customBadge = productBlock.querySelector('.product-badge__item--custom');
            
            if (isVariantOnSale) {
              // Variant is on sale - show red SALE badge, hide custom badge
              if (redSaleBadge) {
                redSaleBadge.style.display = '';
                redSaleBadge.classList.remove('hidden');
              }
              if (customBadge) {
                customBadge.style.display = 'none';
                customBadge.classList.add('hidden');
              }
            } else {
              // Variant is NOT on sale - hide red SALE badge, show custom badge (if exists)
              if (redSaleBadge) {
                redSaleBadge.style.display = 'none';
                redSaleBadge.classList.add('hidden');
              }
              if (customBadge) {
                customBadge.style.display = '';
                customBadge.classList.remove('hidden');
              }
            }

            
          } catch (error) {
            console.error('Error parsing variants on sale data:', error);
            console.error('Raw data was:', variantsOnSaleData);
          }
        }
      }
    });

    // Handle product page variant selection (dropdowns, radio buttons, etc.)
    document.addEventListener('change', function(event) {
      const selector = event.target.closest('[data-single-option-selector]');
      
      if (selector) {
        // Find the product form/section
        const productForm = selector.closest('form[data-product-form]');
        
        if (productForm) {
          // Small delay to ensure the variant input is updated
          setTimeout(() => {
            // Get current variant ID from the form's variant input
            const variantInput = productForm.querySelector('input[name="id"]');
            
            if (variantInput) {
              const currentVariantId = variantInput.value;
              const variantsOnSaleData = productForm.dataset.variantsOnSale;
              

            
            try {
              // Parse the simple format into an object
              const variantsOnSale = {};
              if (variantsOnSaleData && variantsOnSaleData.trim() !== '') {
                const entries = variantsOnSaleData.split(',');
                entries.forEach(entry => {
                  if (entry.includes(':')) {
                    const [id, isOnSale] = entry.split(':');
                    if (id && isOnSale !== undefined) {
                      variantsOnSale[id.trim()] = isOnSale.trim() === 'true';
                    }
                  }
                });
              }
              
              const isVariantOnSale = variantsOnSale[currentVariantId];
              
              // Find both badges in the product page - try form first, then broader scope
              let redSaleBadge = productForm.querySelector('.product-badge__item--sale-red');
              let customBadge = productForm.querySelector('.product-badge__item--custom');
              
              // If not found in form, look in the broader product container
              if (!redSaleBadge) {
                const productContainer = productForm.closest('[data-product-block]') || document;
                redSaleBadge = productContainer.querySelector('.product-badge__item--sale-red');
                customBadge = customBadge || productContainer.querySelector('.product-badge__item--custom');
              }

              
              if (isVariantOnSale) {
                // Variant is on sale - show red SALE badge, hide custom badge
                if (redSaleBadge) {
                  redSaleBadge.style.display = '';
                  redSaleBadge.classList.remove('hidden');
                }
                if (customBadge) {
                  customBadge.style.display = 'none';
                  customBadge.classList.add('hidden');
                }
              } else {
                // Variant is NOT on sale - hide red SALE badge, show custom badge (if exists)
                if (redSaleBadge) {
                  redSaleBadge.style.display = 'none';
                  redSaleBadge.classList.add('hidden');
                }
                if (customBadge) {
                  customBadge.style.display = '';
                  customBadge.classList.remove('hidden');
                }
              }
              
            } catch (error) {
              console.error('Error parsing variants on sale data:', error);
              console.error('Raw data was:', variantsOnSaleData);
            }
            }
          }, 100); // 100ms delay to ensure variant input is updated
        }
      }
    });
  });

  // Video modal functionality
  document.addEventListener('DOMContentLoaded', function() {
    // Handle video badge clicks
    document.addEventListener('click', function(event) {
      const videoBadge = event.target.closest('[data-video-modal-trigger]');
      
      if (videoBadge) {
        event.preventDefault();
        const videoUrl = videoBadge.getAttribute('data-video-url');
        const uniqueId = videoBadge.getAttribute('data-video-modal-trigger') || 'default';
        

        
        // Get or create modal
        let modal = document.getElementById('video-modal-' + uniqueId);
        if (!modal) {
          modal = createVideoModal(uniqueId);
          document.body.appendChild(modal);
        }
        

        
        // Load video content
        loadVideoContent(modal, videoUrl, uniqueId);
        
        // Show modal
        modal.style.display = 'flex';
        modal.style.visibility = 'visible';
        modal.style.opacity = '1';
        modal.classList.add('modal-visible');
        document.body.style.overflow = 'hidden';
        
        // Force styles that might be overridden
        setTimeout(() => {
          modal.style.setProperty('display', 'flex', 'important');
          modal.style.setProperty('position', 'fixed', 'important');
          modal.style.setProperty('top', '0', 'important');
          modal.style.setProperty('left', '0', 'important');
          modal.style.setProperty('width', '100vw', 'important');
          modal.style.setProperty('height', '100vh', 'important');
          modal.style.setProperty('z-index', '10000', 'important');
          modal.style.setProperty('background', 'rgba(0,0,0,0.9)', 'important');
        }, 10);
      }
    });

    // Handle modal close
    document.addEventListener('click', function(event) {
      const closeBtn = event.target.closest('[data-video-modal-close]');
      
      if (closeBtn) {
        const uniqueId = closeBtn.getAttribute('data-video-modal-close');
        closeVideoModal(uniqueId);
      }
    });

    // Close modal when clicking outside content
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('video-modal')) {
        const modalId = event.target.id;
        const uniqueId = modalId.replace('video-modal-', '');
        closeVideoModal(uniqueId);
      }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        const openModal = document.querySelector('.video-modal[style*="flex"]');
        if (openModal) {
          const uniqueId = openModal.id.replace('video-modal-', '');
          closeVideoModal(uniqueId);
        }
      }
    });
  });

  // Create video modal function
  function createVideoModal(uniqueId) {
    const modal = document.createElement('div');
    modal.id = 'video-modal-' + uniqueId;
    modal.className = 'video-modal';
    modal.style.cssText = 'display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.8); z-index: 9999; align-items: center; justify-content: center;';
    
    modal.innerHTML = `
      <div class="video-modal-content" style="position: relative; width: 90%; max-width: 800px; background: white; border-radius: 8px; padding: 20px;">
        <button 
          class="video-modal-close" 
          data-video-modal-close="${uniqueId}"
          style="position: absolute; top: 10px; right: 15px; background: none; border: none; font-size: 24px; cursor: pointer; color: #666;"
        >
          ×
        </button>
        <div class="video-container" style="width: 100%; height: 450px; background: #000; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
          <div id="video-content-${uniqueId}" style="width: 100%; height: 100%;">
            <!-- Video will be loaded here -->
          </div>
        </div>
      </div>
    `;
    
    return modal;
  }

  // Load video content function
  function loadVideoContent(modal, videoUrl, uniqueId) {
    const videoContainer = modal.querySelector('#video-content-' + uniqueId);
    
    if (!videoContainer) {
      return;
    }
    
    // Clear previous content
    videoContainer.innerHTML = '';
    
    let videoId = null;
    

    
    // Check if it's an iframe embed code
    if (videoUrl && videoUrl.includes('<iframe') && videoUrl.includes('</iframe>')) {
      // Extract video ID from iframe src
      const srcMatch = videoUrl.match(/src="[^"]*\/embed\/([^"?]*)/);
      if (srcMatch && srcMatch[1]) {
        videoId = srcMatch[1];
      }
    } else if (videoUrl && videoUrl.trim() !== '') {
      // Try to extract video ID from YouTube URL
      videoId = extractYouTubeId(videoUrl);
    }
    
    // If we have a video ID, create the iframe
    if (videoId) {
      videoContainer.innerHTML = `
        <div style="width: 100%; height: 100%; background: #000; display: flex; align-items: center; justify-content: center;">
          <iframe 
            src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&enablejsapi=1" 
            width="100%" 
            height="100%" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen
            style="min-height: 400px; min-width: 600px;"
          ></iframe>
        </div>
      `;
    } else {
      // Fallback - show direct link
      videoContainer.innerHTML = `
        <div style="background: #333; color: white; padding: 40px; text-align: center; border-radius: 8px;">
          <h3>Watch Video</h3>
          <p>Click the link below to watch the video:</p>
          <a href="${videoUrl}" target="_blank" style="color: #ff0000; font-size: 18px; text-decoration: underline;">
            🎥 Open Video
          </a>
          <br><br>
          <p style="font-size: 14px; opacity: 0.8;">Opens in a new tab</p>
        </div>
      `;
    }
    
    // If iframe doesn't load, show fallback after 3 seconds
    setTimeout(() => {
      if (!videoContainer.querySelector('iframe[src*="youtube"]')) {
        videoContainer.innerHTML = `
          <div style="background: #333; color: white; padding: 40px; text-align: center; border-radius: 8px;">
            <h3>Watch Video</h3>
            <p>Click the link below to watch the video:</p>
            <a href="${videoUrl}" target="_blank" style="color: #ff0000; font-size: 18px; text-decoration: underline;">
              🎥 Open Video
            </a>
            <br><br>
            <p style="font-size: 14px; opacity: 0.8;">Opens in a new tab</p>
          </div>
        `;
      }
    }, 3000);
  }

  // Close video modal function
  function closeVideoModal(uniqueId) {
    const modal = document.getElementById('video-modal-' + uniqueId);
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = ''; // Restore scrolling
      
      // Clear video content to stop playback
      const videoContainer = modal.querySelector('#video-content-' + uniqueId);
      if (videoContainer) {
        videoContainer.innerHTML = '';
      }
    }
  }

  // Extract YouTube video ID
  function extractYouTubeId(url) {
    // Handle various YouTube URL formats:
    // https://www.youtube.com/watch?v=qFgScNo67XM
    // https://youtu.be/qFgScNo67XM
    // https://www.youtube.com/embed/qFgScNo67XM
    // youtube.com/v/qFgScNo67XM
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  // Extract Vimeo video ID
  function extractVimeoId(url) {
    const regExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
    const match = url.match(regExp);
    return match ? match[1] : null;
  }


  // Ensure Opinew plugin is visible after load
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const opinewPlugin = document.getElementById('opinew-plugin');
      if (opinewPlugin) {
        opinewPlugin.style.display = '';
        opinewPlugin.style.visibility = 'visible';
        opinewPlugin.style.opacity = '1';
      }
      const opinewContainer = document.getElementById('opinew-reviews-product-page-code');
      if (opinewContainer) {
        opinewContainer.style.display = '';
        opinewContainer.style.visibility = 'visible';
      }
    }, 100);
  });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();